import {default as SimpleTabs } from './SimpleTabs';
export default SimpleTabs
export * from './SimpleTabs'